/* src/app/components/double-monday-modal/double-monday-modal.css */
.double-monday-modal-root {
  padding: 20px;
  color: white;
}
h1 {
  text-align: center;
  background: black;
  color: white;
}
p {
  margin: 20px 0;
}
.button-container {
  display: flex;
  gap: 10px;
  justify-content: center;
}
.confirm-button {
  --color: black !important;
  --background: cyan !important;
  flex: 1;
}
.confirm-button:hover {
  --background-hover: #00cccc !important;
}
.decline-button {
  --color: cyan !important;
  --background: black !important;
  flex: 1;
}
.decline-button:hover {
  --background: cyan !important;
  --color: black !important;
}
/*# sourceMappingURL=double-monday-modal.css.map */
